import Agreements from '../views/Agreements.vue';
import EditAgreement from '../views/EditAgreement.vue';

export const routes = [
  {
    path: '/freetradeagreement',
    name: 'Agreements',
    component: Agreements,
  },
  {
    path: '/freetradeagreement/:action/:id',
    name: 'EditAgreement',
    component: EditAgreement,
  },
];
